import { render, staticRenderFns } from "./position-detail.vue?vue&type=template&id=ac72de0e&scoped=true"
import script from "./position-detail.vue?vue&type=script&lang=js"
export * from "./position-detail.vue?vue&type=script&lang=js"
import style0 from "./position-detail.vue?vue&type=style&index=0&id=ac72de0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac72de0e",
  null
  
)

export default component.exports